<ng-container [formGroup]="fg">
  <div class="displayInLine">
    <label
      appConfigSettingsParagraph
      [style.color]="fontColor ? fontColor : null"
      [style.font-size.px]="fontSize ? fontSize : null"
      class="datepicker-label"
    >
      <p>
        {{ placeholder | translate }}
        <mat-icon
          *ngIf="additionalInfoInsurer!=null"
          class="infoIcon"
          (click)="openPopup()"
          type="button"
        >info</mat-icon>
      </p>
    </label>
  </div>
  <div>
    <div class="full-width datepicker-container" appearance="outline">
      <div [style.color]="inputColor">
        <input type="hidden" [formControl]="control">
        <input
          type="text"
          [value]="dateInitialValue"
          [mask]="dateMask"
          [matDatepicker]="picker"
          (dateChange)="valueChanged($event)"
          placeholder="{{ showPlaceholder == true ? (datePlaceholder| translate) : ''}}"
          [required]="isRequired"
          [min]="min"
          appConfigSettingsBorder
          appConfigSettingsInput
          [style.borderColor]="inputBorderColor ? inputBorderColor : null"
          [style.color]="inputColor ? inputColor : null"
        />
      </div>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-error *ngIf="isAnyError" class="error-message">
        <ng-container *ngIf="control.errors?.message">
          {{ control.errors.message }}
        </ng-container>
        <ng-container *ngIf="control.errors?.required">
          {{ isRequiredMessage }}
        </ng-container>
      </mat-error>
    </div>
  </div>
</ng-container>
